<template>
  <div class="d-flex justify-content-center">
    <div class="d-flex justify-content-center" v-if="studentGuardianLinkCode">
      <div style="text-align: center;">
        <h3>Your Guardian link code is below:</h3>
        <h4 class="studentGuardianCode">{{studentGuardianLinkCode}}</h4>
        <vs-button @click="copy">Copy</vs-button>
      </div>
    </div>
    <div style="text-align: center; justify-content:center;" v-else>
        <h3>You do not have a Guardian link code. Click the button below to generate a new code.</h3>
        <vs-button ref="generateLinkButton" @click="generateGuardianLinkCode">Generate Code</vs-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
        studentGuardianLinkCode:null
    };
  },
  computed: {
    
  },
  methods: {
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    loadProfileLinks(){
        var self = this;

        var onSuccess = function(response) {
            self.studentGuardianLinkCode = response.data;
        };
        var onFinally = function() {
            
        };

        self.$ajaxGet(self, "User/GetGuardianLinkCodeFromStudent", onSuccess, onFinally);
    },
    generateGuardianLinkCode(){
        var self = this;
        self.showLoadingOnElement("generateLinkButton",0.45,"corners");
        var onSuccess = function(response) {
            self.studentGuardianLinkCode = response.data;
        };
        var onFinally = function() {
            self.$vs.loading.close(self.$refs.generateLinkButton.$el);
        };

        self.$ajaxGet(self, "User/GenerateGuardianLinkCodeForStudent", onSuccess, onFinally);
    },
    copy(){
        var self = this;
        const clipboardData = window.clipboardData ||navigator.clipboard;
        var copyText = self.studentGuardianLinkCode
        clipboardData.writeText(copyText);
        self.$vs.notify({
                title:'Information',
                color: "success",
                text: "Copied",
                position:'top-right',
                iconPack: 'feather',
                icon:'icon-save'
        });
      }
  },
  mounted() {
    var self = this;
    self.loadProfileLinks();
  }
};
</script>

<style lang="scss">
  .studentGuardianCode{
    background: rgba(var(--vs-primary),1);
    padding: 20px;
    border-radius: 13px;
  }
</style>
